import { createRootRoute, Outlet } from "@tanstack/react-router";
import React, { Suspense } from "react";
import Header from "@/components/Header";

const TanStackRouterDevtools =
  import.meta.env.MODE === "production"
    ? () => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import("@tanstack/router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
        }))
      );

export const Route = createRootRoute({
  component: () => (
    <>
      <main className="min-h-screen px-6 flex flex-col items-center justify-center group">
        <Header />
        <article className="w-full max-w-3xl mt-8">
          <Outlet />
        </article>
      </main>
      <Suspense>
        <TanStackRouterDevtools />
      </Suspense>
    </>
  ),
});
